import React from "react";
import {Col, Select, DatePicker} from "antd";
import {useObserver} from "mobx-react-lite";
import moment from "moment";
import {ZoneSelect} from "components/_defaultComponents/ZoneSelect";
import {ZoneManagementSelect} from "components/_defaultComponents/ZoneManagementSelect";
import SearchText from "components/_defaultComponents/FilterComponents/SearchText";

const {RangePicker} = DatePicker;

const Filters = ({setFilters, filters, setCurrentPage}) => {
    const handleFilterChange = (field, value) => {
        setCurrentPage(1);
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleZoneManagementChange = value => {
        setCurrentPage(1);
        setFilters(prev => ({
            ...prev,
            zoneManagementId: value,
            zoneId: undefined
        }));
    };

    const handleDateChange = dates => {
        setCurrentPage(1);
        if (dates && dates.length === 2) {
            setFilters(prev => ({
                ...prev,
                startDate: dates[0].format("YYYY-MM-DD"),
                endDate: dates[1].format("YYYY-MM-DD")
            }));
        } else {
            setFilters(prev => ({
                ...prev,
                startDate: undefined,
                endDate: undefined
            }));
        }
    };

    return useObserver(() => (
        <>
            <Col xs={24} sm={12} lg={5}>
                <RangePicker
                    style={{width: "100%"}}
                    placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
                    onChange={handleDateChange}
                    format="DD/MM/YYYY"
                    value={
                        filters.startDate && filters.endDate
                            ? [moment(filters.startDate), moment(filters.endDate)]
                            : null
                    }
                />
            </Col>
            <Col xs={24} sm={12} lg={5}>
                <SearchText
                    value={filters.searchText}
                    onChange={value => handleFilterChange("searchText", value)}
                    showLabel={false}
                    showPlaceholder
                    placeholder="Ad Soyad veya Telefon Ara"
                />
            </Col>
            <Col xs={24} sm={12} lg={5}>
                <ZoneManagementSelect
                    value={filters.zoneManagementId}
                    onChange={handleZoneManagementChange}
                    showTitle={false}
                    marginBottom="0"
                    placeholder="Bölge Müdürlüğü"
                    allowClear={true}
                />
            </Col>
            <Col xs={24} sm={12} lg={5}>
                <ZoneSelect
                    zoneManagementId={filters.zoneManagementId}
                    value={filters.zoneId}
                    onChange={value => handleFilterChange("zoneId", value)}
                    showTitle={false}
                    marginBottom="0"
                    placeholder="Bölge"
                    allowClear={true}
                    showSyUser={false}
                />
            </Col>
            <Col xs={24} sm={12} lg={4}>
                <Select
                    placeholder="Durum"
                    style={{width: "100%"}}
                    value={filters.status}
                    onChange={value => handleFilterChange("status", value)}
                >
                    <Select.Option value="all">Tümü</Select.Option>
                    <Select.Option value="pending">Bekliyor</Select.Option>
                    <Select.Option value="approved">Onaylandı</Select.Option>
                </Select>
            </Col>
        </>
    ));
};

export default Filters;
